import { REDUX_ACTIONS } from "constants/constants";

export const pushItemsToCart = (data) => ({
  type: REDUX_ACTIONS.ADD_ITEMS_TO_CART,
  payload: data,
});

export const pushCouponCodeToCart = (data) => ({
  type: REDUX_ACTIONS.PUSH_COUPON_CODE_TO_CART,
  payload: data,
});

export const resetCart = () => ({ type: REDUX_ACTIONS.RESET_CART });
